import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';

import { SecurityService } from './security.service';
import { SecurityInterceptor } from './security.interceptor';

@Injectable()
export class RefreshInterceptor implements HttpInterceptor {
  private attempts: { [key: string]: boolean };

  constructor(private securityService: SecurityService, private securityInterceptor: SecurityInterceptor) {
    this.attempts = {};
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(
        (response: HttpErrorResponse): Observable<HttpEvent<any>> => {
          if ((response.status === 401 && request.url.endsWith('/auth/refresh')) || response.status !== 401) {
            return throwError(response);
          }

          if (this.attempts[request.url]) {
            this.securityService.emitUnauthorized();
            return throwError(response);
          }

          return this.retry(request, next);
        }
      )
    );
  }

  private retry(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.attempts[request.url] = true;

    return this.securityService.emitRefresh().pipe(
      mergeMap(() => {
        delete this.attempts[request.url];
        return this.securityInterceptor.intercept(request, next);
      }),
      catchError((error: HttpErrorResponse) => throwError(error))
    );
  }
}
